import { useTheme } from '@mui/material';
export const getBackgroundColorByOppType = (type) => {
    const theme = useTheme();
    switch (type) {
        case 'Small Business':
            return theme.palette.green[800];
        case 'Federal':
        case 'Federal Opps':
            return theme.palette.green[500];
        case 'Private Foundations':
            return theme.palette.green[400];
        default:
            return theme.palette.green[900];
    }
};
